// src/features/reservations/lib/reservationsQuery.ts
//
// Query string of GET /api/v1/ui/reservations. Multi-value filters (state,
// channelUsed) go as repeated parameters — `state=a&state=b` — which the
// server reads as "any of"; a comma-joined value used to arrive as one state
// that matched nothing.
import queryString from 'query-string';
import type { ReservationsFilter } from '@/types/reservationState';

export const reservationsQueryString = (filter: ReservationsFilter): string =>
  queryString.stringify(
    {
      ...filter,
      state: filter.state && filter.state.length ? filter.state : undefined,
      channelUsed: filter.channelUsed && filter.channelUsed.length ? filter.channelUsed : undefined,
    },
    { arrayFormat: 'none', skipNull: true, skipEmptyString: true }
  );
